import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { INFRASTRUCTURE } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import StreetviewActions from '../redux/streetviewRedux'

const id = 'Infrastructure'
const authId = 'Infrastructure'
const sourceLayer = 'Infrastructure'

export class Infrastructure extends Component {
  componentDidMount () {
    const { map } = this.context
    map.on('mouseover', id, this.handleMouseOver)
    map.on('mouseout', id, this.handleMouseOut)
    map.on('click', id, this.handleClick)
  }

  componentWillUnmount () {
    const { map } = this.context
    map.off('mouseover', id, this.handleMouseOver)
    map.off('mouseout', id, this.handleMouseOut)
    map.off('click', id, this.handleClick)
  }
  
  handleMouseOver = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })
    
    map.getCanvas().style.cursor = features.length > 0 ? 'pointer' : ''
  }

  handleMouseOut = event => {
    const { map } = this.context

    map.getCanvas().style.cursor = ''
  }

  handleClick = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    const { features } = event
    if (features.length > 0) {
      actions.streetviewAdded(event.lngLat)
    }
  }
  
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props
    const id = 'Infrastructure'
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''
    const vectorSource = {
      type: 'vector',
      tiles: [INFRASTRUCTURE({ idToken, timeIso })],
      tileSize: 512
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source id='Infrastructure' tileJsonSource={vectorSource} />
        <Layer
          type='circle'
          id='Infrastructure'
          sourceId='Infrastructure'
          sourceLayer='infrastructure'
          paint={paint}
        />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        id,
        authId
      ),
      paint: getPaint(state, id),
      time: state.layer.times[id] || undefined
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      streetviewAdded: lngLat => dispatch(StreetviewActions.streetviewAdded(lngLat))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(Infrastructure)



// WEBPACK FOOTER //
// ./src/layers/Infrastructure.js